import type { SectionProps } from '@/types';

/**
 * Renders the admin-authored HTML block for the "custom_html" site type.
 * The backend has already substituted `{variable}` placeholders with this
 * business's own values (HTML-escaped) — see `app/utils/templating.py` and
 * `BusinessService._resolve_template`. There is nothing left to interpolate
 * on the client, we just need to mount the markup.
 */
export function CustomHtmlSection({ config }: SectionProps) {
  const renderedHtml = (config.rendered_html as string) || '';
  if (!renderedHtml.trim()) return null;

  return (
    <section
      className="section-card custom-html-section"
      dangerouslySetInnerHTML={{ __html: renderedHtml }}
    />
  );
}
